import React, { forwardRef } from 'react'
import styles from './TableBodyContainer.module.scss'
import cl from 'classnames'
import { TableBodyContainerProps } from './TableBodyContainer.types'

const TableBodyContainerComponent = (props: TableBodyContainerProps, ref) => {
  const {
    className,
    children,
    ...rest
  } = props

  // const ref = useRef<HTMLDivElement>(null)

  // useEffect(() => {
  //   const hasHorizontalScrollBar = ref.current?.scrollWidth > ref.current?.clientWidth
  //   console.log({ hasHorizontalScrollBar })
  //   // if (ref.current) {
  //   //   ref.current.addEventListener('load', (e) => { console.log('e', e) })
  //   // }

  //   // setTimeout(() => {
  //   //   const hasHorizontalScrollBar = ref.current?.scrollWidth > ref.current?.clientWidth
  //   //   console.log({ hasHorizontalScrollBar })
  //   // }, 5000)
  // }, [ref, children])

  return (
    <div
      ref={ref}
      className={cl(styles.tableBody, styles.scrollable, className)}
      {...rest}
    >
      {children}
      {/* <div className={styles.horizontalScrollContainer}>

      </div> */}
    </div>
  )
}

const TableBodyContainer = forwardRef(TableBodyContainerComponent)
export { TableBodyContainer }
